import axios from 'axios';
import { wixAxiosInstanceConfig } from '@wix/wix-axios-config';

export const LOCALE_HOST = 'https://apps.wixrestaurants.com';
export const LOCALE_PATH = '/i18n';

export function constructPath(locale) {
  return `${LOCALE_PATH}/${locale}`;
}

export default class Client {
  constructor() {
    this.instance = wixAxiosInstanceConfig(axios, { baseURL: LOCALE_HOST });
  }

  getLocaleData(locale) {
    return this.instance.get(constructPath(locale));
  }
}
